import { render } from "./View403.vue?vue&type=template&id=020572a2&scoped=true&ts=true"
import script from "./View403.vue?vue&type=script&lang=ts"
export * from "./View403.vue?vue&type=script&lang=ts"

import "./View403.vue?vue&type=style&index=0&id=020572a2&lang=sass&scoped=true"

import exportComponent from "D:\\workspace\\com.xiansheng\\MiezzGitPull\\Miezz\\Miezz.Web.Entry\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-020572a2"]])

export default __exports__